function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import { css } from '@emotion/react';
import breakpoints from '../../visid/breakpoints';
import containerSizeStyleSwitcher from '../../functions/container-size-style-switcher';
var modifiers = {
  none: 0,
  mi: 4,
  xs: 8,
  sm: 12,
  md: 16,
  lg: 24,
  xl: 32,
  gi: 40
};
var generateRhythm = function generateRhythm(attr, value) {
  if (value && _typeof(value) === 'object') {
    return Object.keys(value).map(function (key) {
      /** Ignore invalid breakpoints */
      if (!breakpoints[key]) {
        return;
      }
      /** Create media query for breakpoint */
      var minWidth = breakpoints[key][0];
      var maxWidth = breakpoints[key][1];
      var minWidthQry = minWidth ? "(min-width: ".concat(minWidth, "px)") : undefined;
      var maxWidthQry = maxWidth ? "(max-width: ".concat(maxWidth, "px)") : undefined;
      var style = "".concat(attr, ": ").concat(modifiers[value[key]], "px");
      return /*#__PURE__*/css("@media ", [minWidthQry, maxWidthQry].filter(Boolean).join(' and '), "{", style, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:generateRhythm;"));
    });
  }
  return "".concat(attr, ": ").concat(modifiers[value], "px;");
};
var generateFlex = function generateFlex(attr, value) {
  var containerSize = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var attrVal = containerSizeStyleSwitcher(value, containerSize);
  switch (attrVal) {
    case 'top':
      return /*#__PURE__*/css(attr, ":flex-start;" + (process.env.NODE_ENV === "production" ? "" : ";label:generateFlex;"));
    case 'bottom':
      return /*#__PURE__*/css(attr, ":flex-end;" + (process.env.NODE_ENV === "production" ? "" : ";label:generateFlex;"));
    default:
      return /*#__PURE__*/css(attr, ":", attrVal, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:generateFlex;"));
  }
};
var _ref = process.env.NODE_ENV === "production" ? {
  name: "wi45xu",
  styles: "transform:translateX(-1rem);width:calc(100% + 2rem)"
} : {
  name: "1u7323p-generateFlush",
  styles: "transform:translateX(-1rem);width:calc(100% + 2rem);label:generateFlush;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var generateFlush = function generateFlush(value) {
  if (value && _typeof(value) === 'object') {
    return Object.keys(value).map(function (key) {
      /** Ignore invalid breakpoints */
      if (!breakpoints[key]) {
        return;
      }
      /** Create media query for breakpoint */
      var minWidth = breakpoints[key][0];
      var maxWidth = breakpoints[key][1];
      var minWidthQry = minWidth ? "(min-width: ".concat(minWidth, "px)") : undefined;
      var maxWidthQry = maxWidth ? "(max-width: ".concat(maxWidth, "px)") : undefined;
      if (value[key] === true) {
        return /*#__PURE__*/css("@media ", [minWidthQry, maxWidthQry].filter(Boolean).join(' and '), "{transform:translateX(-1rem);width:calc(100% + 2rem);}" + (process.env.NODE_ENV === "production" ? "" : ";label:generateFlush;"));
      }
    });
  }
  return _ref;
};
var generateResponsive = function generateResponsive(value) {
  var displayValueArray = [];
  if (typeof value === 'string') {
    displayValueArray.push({
      displayValue: value.split('@')[0],
      sizeValue: value.split('@')[1]
    });
  } else {
    value.forEach(function (val) {
      displayValueArray.push({
        displayValue: val.split('@')[0],
        sizeValue: val.split('@')[1]
      });
    });
  }
  var mediaQueries = "";
  var getMediaQuery = function getMediaQuery(val) {
    var setDisplayValue = ['inline', 'inline-block', 'block'].includes(val.displayValue) ? val.displayValue : 'none';
    switch (val.sizeValue) {
      case 'sm':
        return "\n          @media (max-width: ".concat(breakpoints.sm[1] - 1, "px) {\n            display: ").concat(setDisplayValue, ";\n          }\n        ");
      case 'md':
        return "\n          @media (min-width: ".concat(breakpoints.md[0], "px) and (max-width: ").concat(breakpoints.md[1], "px) {\n            display: ").concat(setDisplayValue, ";\n          }\n        ");
      case 'lg':
        return "\n          @media (min-width: ".concat(breakpoints.lg[0] + 1, "px) and (max-width: ").concat(breakpoints.lg[1], "px) {\n            display: ").concat(setDisplayValue, ";\n          }\n        ");
      case 'xl':
        return "\n          @media (min-width: ".concat(breakpoints.xl[0] + 1, "px) {\n            display: ").concat(setDisplayValue, ";\n          }\n        ");
    }
  };
  displayValueArray.forEach(function (val) {
    mediaQueries += getMediaQuery(val);
  });
  return /*#__PURE__*/css(mediaQueries, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:generateResponsive;"));
};
var generateOverflow = function generateOverflow(overflow, overflowHidden, overflowX, overflowY) {
  return "\n    ".concat(overflow ? "overflow: ".concat(overflow, ";") : '', "\n    ").concat(overflowHidden ? "overflow-hidden: ".concat(overflowHidden, ";") : '', "\n    ").concat(overflowX ? "overflow-x: ".concat(overflowX, ";") : '', "\n    ").concat(overflowY ? "overflow-y: ".concat(overflowY, ";") : '', "\n  ");
};

// eslint-disable-next-line complexity, sonarjs/cyclomatic-complexity
var helperStyles = function helperStyles(_ref2) {
  var utils = _ref2.utils;
  if (!utils) {
    return;
  }
  /** Rhythm / Spacing / Flex(self) / Overflow */
  var hrLeft = utils.hrLeft,
    hrRight = utils.hrRight,
    vrTop = utils.vrTop,
    textColor = utils.textColor,
    vrBottom = utils.vrBottom,
    alignSelf = utils.alignSelf,
    flexShrink = utils.flexShrink,
    flexGrow = utils.flexGrow,
    flexOrder = utils.flexOrder,
    flexDirection = utils.flexDirection,
    containerSize = utils.containerSize,
    srOnly = utils.srOnly,
    fullWidth = utils.fullWidth,
    isFlush = utils.isFlush,
    responsive = utils.responsive,
    overflow = utils.overflow,
    overflowHidden = utils.overflowHidden,
    overflowX = utils.overflowX,
    overflowY = utils.overflowY,
    noMargin = utils.noMargin;
  return /*#__PURE__*/css(hrLeft && generateRhythm('margin-left', hrLeft), " ", hrRight && generateRhythm('margin-right', hrRight), " ", vrTop && generateRhythm('margin-top', vrTop), " ", vrBottom && generateRhythm('margin-bottom', vrBottom), " ", noMargin && generateRhythm('margin', 'none'), " ", alignSelf && generateFlex('align-self', alignSelf, containerSize), " ", flexShrink && generateFlex('flex-shrink', flexShrink, containerSize), " ", flexGrow && generateFlex('flex-grow', flexGrow, containerSize), " ", flexOrder && generateFlex('order', flexOrder, containerSize), " ", flexDirection && generateFlex('flex-direction', flexDirection, containerSize), " ", (overflow || overflowHidden || overflowX || overflowY) && generateOverflow(overflow, overflowHidden, overflowX, overflowY), " ", isFlush && generateFlush(isFlush), textColor && "color: ".concat(textColor), srOnly && "\n      border: 0;\n      height: 0.1rem;\n      margin: -0.1rem;\n      overflow: hidden;\n      padding: 0;\n      position: absolute;\n      width: 0.1rem;\n    ", fullWidth && "\n      width: 100%;\n    ", " ", responsive && generateResponsive(responsive), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:helperStyles;"));
};
export default helperStyles;